jQuery(document).ready(function($){
    const ageConfirmed = window.localStorage.getItem('glassDamage');
    const cookieConfirmed = window.localStorage.getItem('cookieConfirm');
    // if (!ageConfirmed) {
    //     $(`#glass-damage`).show();
    //     $('body').addClass('none-vis');
    // }

    if (!cookieConfirmed) {
        if(ageConfirmed) {
            $(`#cookie-conf`).show();
        }

        // $('body').addClass('none-vis');
    }

    /*$("#glass-damage .img-cont-wrp").mousemove(function (e) {
        var parentOffset = $(this).offset();
        if($(e.target).hasClass('newsletter__input') || $(e.target).hasClass('newsletter__submit') ||  $(e.target).hasClass('close-btn') || $(e.target).hasClass('input-group__btn')) {
            $('.cursor').hide();
        } else {
            $(".cursor").css({
                "left": e.pageX - parentOffset.left,
                "top":e.pageY - parentOffset.top
            }).show();
        }
    }).mouseout(function () {
        $(".cursor").hide();
    });*/
    $('.site-popup__newsletter input[type="email"]').on('click' ,function(e){
        e.stopPropagation();
    });
    $('.site-popup__newsletter input[type="email"]').on('input keypress change',function(){
        if($(this).hasClass('error')) {
            $(this).removeClass('error')
        }
    });
    $('.site-popup__newsletter .newsletter__submit').on('click',function(e){
        e.stopPropagation();
        e.preventDefault();
        var email = $('.site-popup__newsletter input[type="email"]').val();
        submitForm(email);
    });
    $('.site-popup__newsletter form').on('submit',function(e){
        e.stopPropagation();
        e.preventDefault();
        var email = $('.site-popup__newsletter input[type="email"]').val();
        submitForm(email);
    });
    function submitForm(email) {
        var  emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailReg.test(String(email).toLowerCase())) {
            $('.site-popup__newsletter input[type="email"]').addClass('error');
        } else {
            var settings = {
                "async": true,
                "crossDomain": true,
                "url": "/contact",
                "method": "POST",
                "headers": {
                    "content-type": "application/x-www-form-urlencoded",
                },
                "data": {
                    "form_type": "customer",
                    "utf8": "✓",
                    "contact[tags]": "newsletter",
                    "contact[email]": email,
                    "commit": ""
                }
            };
            $.ajax(settings).done(function (response) {
                //$("#glass-damage").fadeOut(200);
                $("#glass-damage").addClass('thank')
                window.localStorage.setItem('glassDamage', true);
                setTimeout(function(){
                    $('body').removeClass('none-vis');
                },230);
            });
        }
    }
    $("#glass-damage .overlay,#glass-damage .close-btn").on('click',function(e){
        e.preventDefault();
        //sessionStorage.setItem('glassDamage', true);
        $("#glass-damage").hide();
        $('body').removeClass('none-vis');
        if(!cookieConfirmed) {
            $("#cookie-conf").show()
        }
    });
    $("#cookie-conf .close-btn").on('click', function(e) {
        e.preventDefault();
        $("#cookie-conf").hide()
        $('body').removeClass('none-vis');
    })
    $("#cookie-conf button.accept").on('click', function(e) {
        e.preventDefault();
        window.localStorage.setItem('cookieConfirm', true);
        $("#cookie-conf").hide()
        $('body').removeClass('none-vis');
    })
    /*$("#glass-damage .img-cont-wrp").on('click',function(e){
        e.preventDefault();
        //if($(e.target).hasClass('.site-popup__newsletter')) return false;
        if($("#glass-damage").hasClass('clicked')) return false;
        $("#glass-damage").addClass('clicked');
        var parentOffset = $(this).offset();
        //sessionStorage.setItem('glassDamage', true);
        var _this  = $(this),
            dWidth = $('.damage-glass').width(),
            dHeight = $('.damage-glass').height(),
            posTop = e.pageY - parentOffset.top + 30 - dWidth / 2 ,
            posLeft = e.pageX - parentOffset.left - dHeight / 3;
        _this.find('.cursor').addClass('gmp');
        setTimeout(function(){
            _this.find('.cursor').removeClass('gmp');
            $('.damage-glass').css({top: posTop+'px', left: posLeft+'px'});
            $('.damage-glass').addClass('show');
            setTimeout(function(){
                $('.damage-glass').addClass('visible');
                $('#glass-damage').addClass('rotate');
            },250)
            setTimeout(function(){
                $("#glass-damage").fadeOut(200);
                setTimeout(function(){
                    $('body').addClass('visible');
                },230);
            },800)
        },180);
    });*/
});